const nonFloatAddition = (a: number, b: number): number =>
  (a * 100 + b * 100) / 100

export default nonFloatAddition
